import { render, staticRenderFns } from "./searchCenter.vue?vue&type=template&id=c6b50daa&scoped=true&"
import script from "./searchCenter.vue?vue&type=script&lang=js&"
export * from "./searchCenter.vue?vue&type=script&lang=js&"
import style0 from "./searchCenter.vue?vue&type=style&index=0&id=c6b50daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b50daa",
  null
  
)

export default component.exports